import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IdentificationSection() {
  const mistakes = ['Esperar señales claras antes de actuar', 'Evitar cualquier tipo de tensión', 'Confundir respeto con neutralidad emocional', 'Intentar agradar antes de provocar interés', "Ser 'el tipo perfecto' que nunca genera nada"];
  return <section className="py-24 bg-secondary relative" data-id="element-103">
      <div className="max-w-4xl mx-auto px-6" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-106">
            ¿Te suena familiar?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-107">
            La mayoría de los hombres caen en los mismos errores una y otra vez,
            creyendo que están haciendo lo correcto.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-108">
          {mistakes.map((mistake, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center p-6 bg-tertiary rounded-lg border border-white/5 hover:border-gold/20 transition-colors duration-300" data-id="element-109">
              <div className="h-3 w-3 rounded-full bg-gold mr-6 flex-shrink-0 shadow-[0_0_10px_rgba(201,168,76,0.5)]" data-id="element-110" />
              <p className="text-lg text-gray-200 font-medium" data-id="element-111">{mistake}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-112">
          <p className="text-gold text-xl font-medium tracking-wide" data-id="element-113">
            Si te identificás con al menos dos de estos puntos, seguí leyendo.
          </p>
        </motion.div>
      </div>
    </section>;
}